export { ItButton } from './it-button.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/if-defined.js';

const BUTTON_SIZES = ['lg', 'sm', 'xs'];
const BUTTON_VARIANTS = ['primary', 'secondary', 'success', 'danger', 'warning', 'link'];

export { BUTTON_SIZES, BUTTON_VARIANTS };
//# sourceMappingURL=index.js.map
